/* eslint-disable i18next/no-literal-string */
import React from "react";
import styles from "./form-field.module.scss";
import classnames from "classnames";
import globalStyles from "../../globalStyles";
import { useTranslation } from "react-i18next";

export const FormFieldV2: React.FC<{ className?: string; errorText?: string; showError?: boolean; children?: React.ReactNode }> = ({ ...props }) => {
  const { t } = useTranslation();
  return (
    <div className={classnames(styles.formField, props.className, { [globalStyles["form-error"]]: props.showError })}>
      {props.children}
      {props.showError && (
        <div className={styles.errorText} data-testid="form-error-text">
          {t(props.errorText || "")}
        </div>
      )}
    </div>
  );
};
